var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 1.05997L6.58 6.59997C6.21 6.96997 6 7.47997 6 8.00997V18C6 19.1 6.9 20 8 20H17C17.8 20 18.52 19.52 18.84 18.79L22.1 11.18C22.94 9.19997 21.49 6.99997 19.34 6.99997H13.69L14.64 2.41997C14.74 1.91997 14.59 1.40997 14.23 1.04997C13.64 0.469969 12.7 0.469969 12.12 1.05997ZM2 20C3.1 20 4 19.1 4 18V9.99997C4 8.89997 3.1 7.99997 2 7.99997C0.9 7.99997 0 8.89997 0 9.99997V18C0 19.1 0.9 20 2 20Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardType1);
export default __webpack_public_path__ + "static/media/card_type_1.58dd721829ab8e23c6d4c5c84ebb9fea.svg";
export { ForwardRef as ReactComponent };